import { LEAD_STATUS_COLORS } from "../../design/tokens";

export default function LeadStatusBadge({ status }) {
  const c = LEAD_STATUS_COLORS[status] || LEAD_STATUS_COLORS["New"];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 6, fontSize: 11, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600, background: c.bg, color: c.text, border: `1px solid ${c.border}` }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: c.text, display: "inline-block", flexShrink: 0 }} />
      {status || "New"}
    </span>
  );
}
